import { render, staticRenderFns } from "./BDXStatusModalFiltersDropdown.vue?vue&type=template&id=caa0723e&scoped=true"
import script from "./BDXStatusModalFiltersDropdown.vue?vue&type=script&lang=js"
export * from "./BDXStatusModalFiltersDropdown.vue?vue&type=script&lang=js"
import style0 from "./BDXStatusModalFiltersDropdown.vue?vue&type=style&index=0&id=caa0723e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa0723e",
  null
  
)

export default component.exports